export default __webpack_public_path__ + "static/scores@768-5a5d75d024298e4dff19c6152efb18ff.png";